module.exports = __webpack_public_path__ + "img/logo_rodeo.29a626cf.png";